import { Grid, Stack, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import EditPermission from 'components/Account/EditPermission'
import EditStatus from 'components/Account/EditStatus'
import EditName from 'components/EditName'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

export default function AccountDetail() {
  const { id } = useParams<{ id: string }>()
  const auth = useAppSelector((s) => s.UI.auth)
  const permission = useAppSelector((s) =>
    s.Account.list.find((f) => f.id === auth?.id)
  )?.permission
  const account = useAppSelector((s) => s.Account.list.find((f) => f.id === id))
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (id)
      dispatch(
        UIAction.setBreadcrumbs([
          {
            text: 'ホーム',
            url: '/',
          },
          {
            text: 'アカウント管理',
            url: '/account',
          },
          {
            text: 'アカウント詳細',
            url: '/account/' + id,
          },
        ])
      )
  }, [dispatch, id])
  if (!account) return null
  return (
    <Grid container spacing={1} mt={2}>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{ borderBottom: 2 }}
        >
          アカウント情報
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Stack
          direction={{
            xs: 'column',
            md: 'row',
          }}
          spacing={1}
          alignItems={{
            xs: 'flex-start',
            md: 'center',
          }}
          justifyContent="space-between"
          my={2}
        >
          <Typography variant="h6" component="h3" fontWeight="bold" ml={1}>
            {account.lastName} {account.firstName}
          </Typography>
        </Stack>
      </Grid>
      {permission === 'admin' ? (
        <Grid item xs={12} ml={1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
              <Stack ml={1}>
                <EditName
                  label="氏名"
                  apiEndpoint={'/api/system/' + id}
                  lastName={account.lastName}
                  firstName={account.firstName}
                />
              </Stack>
              <Stack
                ml={1}
                my={2}
                direction="row"
                spacing={2}
                alignItems={{
                  md: 'center',
                  xs: 'flex-start',
                }}
              >
                <Typography fontWeight="bold" variant="body2" minWidth={60}>
                  メールアドレス
                </Typography>
                <Stack direction="row" alignItems="center">
                  <Typography>{account.id}</Typography>
                </Stack>
              </Stack>
              <Stack
                ml={1}
                direction="row"
                spacing={2}
                alignItems={{
                  md: 'center',
                  xs: 'flex-start',
                }}
              >
                <Stack direction="row" alignItems="center">
                  <EditPermission
                    label="権限"
                    apiEndpoint={'/api/system/' + id}
                    permission={account.permission}
                  />
                </Stack>
              </Stack>
              <Stack
                ml={1}
                direction="row"
                spacing={2}
                alignItems={{
                  md: 'center',
                  xs: 'flex-start',
                }}
              >
                <Stack direction="row" alignItems="center">
                  <EditStatus
                    label="ステータス"
                    apiEndpoint={'/api/system/' + id}
                    status={account.status}
                    my={2}
                  />
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid item xs={12} ml={1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
              <Stack
                ml={1}
                my={2}
                direction="row"
                spacing={2}
                alignItems={{
                  md: 'center',
                  xs: 'flex-start',
                }}
              >
                <Typography fontWeight="bold" variant="body2" minWidth={60}>
                  氏名
                </Typography>
                <Stack direction="row" alignItems="center">
                  <Typography>
                    {account.lastName} {account.firstName}
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                ml={1}
                my={2}
                direction="row"
                spacing={2}
                alignItems={{
                  md: 'center',
                  xs: 'flex-start',
                }}
              >
                <Typography fontWeight="bold" variant="body2" minWidth={60}>
                  メールアドレス
                </Typography>
                <Stack direction="row" alignItems="center">
                  <Typography>{account.id}</Typography>
                </Stack>
              </Stack>
              <Stack
                ml={1}
                my={2}
                direction="row"
                spacing={2}
                alignItems={{
                  md: 'center',
                  xs: 'flex-start',
                }}
              >
                <Typography fontWeight="bold" variant="body2" minWidth={60}>
                  権限
                </Typography>
                <Stack direction="row" alignItems="center">
                  <Typography>
                    {
                      {
                        admin: '管理者',
                        subAdmin: '副管理者',
                        standard: '一般',
                      }[account.permission]
                    }
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                ml={1}
                my={2}
                direction="row"
                spacing={2}
                alignItems={{
                  md: 'center',
                  xs: 'flex-start',
                }}
              >
                <Typography fontWeight="bold" variant="body2" minWidth={60}>
                  ステータス
                </Typography>
                <Stack direction="row" alignItems="center">
                  <Typography>
                    {
                      {
                        preActive: '登録済み',
                        active: '利用中',
                        deleted: '削除済み',
                      }[account.status]
                    }
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}
